import '@ui5/webcomponents/dist/Card.js';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `Card` is a component that represents information in the form of a tile with separate header and content areas. The content area of a `Card` can be arbitrary HTML content. The header can be used through slot `header`. For which there is a `Card-header` component to achieve the card look and fill. Note: We recommend the usage of `Card-header` for the header slot, so advantage can be taken for keyboard handling, styling and accessibility.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/Card" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const Card = withWebComponent('ui5-card', ['accessibleName', 'accessibleNameRef'], [], ['header'], []);
Card.displayName = 'Card';
export { Card };
